import { normalizeContentVersion } from '@/utils/chapterContentVersion'

function scopeKey(projectId: string, chapterId: string): string {
  return `${projectId}:${chapterId}`
}

/** Last allocated nextVersion counter per chapter (starts at server contentVersion on load). */
const nextVersionCounterByScope = new Map<string, number>()

export function resetChapterNextVersionCounter(
  projectId: string,
  chapterId: string,
  serverContentVersion: number,
): void {
  nextVersionCounterByScope.set(
    scopeKey(projectId, chapterId),
    normalizeContentVersion(serverContentVersion),
  )
}

export function clearChapterNextVersionCounter(projectId: string, chapterId: string): void {
  nextVersionCounterByScope.delete(scopeKey(projectId, chapterId))
}

/** Increments per save attempt; first value after load is serverContentVersion + 1. */
export function ensureChapterNextVersionCounter(
  projectId: string,
  chapterId: string,
  serverContentVersion: number,
): void {
  const key = scopeKey(projectId, chapterId)
  if (!nextVersionCounterByScope.has(key)) {
    resetChapterNextVersionCounter(projectId, chapterId, serverContentVersion)
  }
}

export function allocateChapterNextVersion(projectId: string, chapterId: string): number {
  const key = scopeKey(projectId, chapterId)
  const base = nextVersionCounterByScope.get(key) ?? 0
  const allocated = base + 1
  nextVersionCounterByScope.set(key, allocated)
  return allocated
}
